import { type FC } from "react";
import { PhotosTab } from "./photos-tab";

export const UnsplashTab: FC<{
  onImageClick?: (imageUrl: string) => void;
  selectedImage: string | null;
  onSelectionChange?: (hasSelection: boolean) => void;
  hidden?: boolean;
}> = (props) => {
  return <PhotosTab endpoint="/photos/stock" placeholder="Search Unsplash" {...props} />;
};
